module.exports = __webpack_public_path__ + "img/resetQRCode.005e9423.jpg";